import ApiDispatchDrivers from '../api/dispatch/drivers'

class NotifOnOffDuty {
  process (VueApp, payload) {
    let onDuty = payload.onDuty === 'true'
    let driverId = payload.driverId

    ApiDispatchDrivers.updateDriverLists(VueApp, driverId, onDuty)
  }
}

export default new NotifOnOffDuty()



// WEBPACK FOOTER //
// ./src/modules/notifications/notif-onoffduty.js